import React, { Component } from 'react';

import './Mensagens.scss';

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Fade from 'react-reveal/Fade';
import renderHTML from 'react-render-html';

import OwlCarousel from 'react-owl-carousel2';
import '../../../node_modules/react-owl-carousel2/src/owl.carousel.css';
import '../../../node_modules/react-owl-carousel2/lib/styles.css';

import {
    Accordion,
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';

import {
    Dispatcher,
    Actions,
    Events
} from '../../flux';

import {
	images,
	mensagens_content
} from '../../settings';

class Mensagens extends Component {

	constructor() {
		super();

        this.images = images;
        this.mensagens_content = mensagens_content;

        this.state = {
            width: window.innerWidth,
            selectedPerson: this.mensagens_content[0],
            changingContent: false
        };

	    this.scrollTop = this.scrollTop.bind(this);
	    this.globalTransition = this.globalTransition.bind(this);
	    this.changePerson = this.changePerson.bind(this);
	}

	scrollTop() {
		this.refs.contentText.scrollTop = 0;
	}

    globalTransition() {
    	Actions.globalTransition();
    }

    changePerson(index) {
    	this.setState({ changingContent: true });

    	setTimeout(function() {
	    	this.setState({ selectedPerson: {
	    		title: "",
	    		name: "",
	    		second_name: "",
	    		text: "",
	    		image: "",
	    	}});
	    	
	    	setTimeout(function() {
		    	this.setState({ selectedPerson: this.mensagens_content[index] });
	    	}.bind(this), 20);

	    	setTimeout(function() {
    			this.setState({ changingContent: false });
	    	}.bind(this), 500);

    	}.bind(this), 500);
    }

	componentWillMount() {
    	Actions.menuIntern();
    	Actions.logoIntern();
    	Actions.showFooter();
		Actions.emitPage('01 Mensagens');
    }

    componentWillUnmount() {
	}

    componentDidMount() {
    }

	render() {
        const { width, changingContent } = this.state;
        const isMobile = width <= 769;

		var classItem = [
			'view',
			'mensagens'
		];

		const selectors = [];
		for (let i = 0; i < this.mensagens_content.length; i++) {
			let sClass = [
				'selector',
				(this.state.selectedPerson.name == this.mensagens_content[i].name) ? 'selector--active' : ''
			];
			selectors.push(
				<div key={i} className={ sClass.join(' ') } onClick={ this.changePerson.bind(null, i) }>
					<div className="sel">
	    				<div className="person_icon">
	        				<div className="person_icon__circle">
								<img src={ this.mensagens_content[i].image } />
	        				</div>
	    				</div>
					</div>
					<div className="position">{ this.mensagens_content[i].title }</div>
				</div>
			);
		}

		const contentClasses = [
			'mensagens_content',
			(changingContent) ? 'mensagens_content--hide' : ''
		];

		const imageClasses = [
			'person_photo',
			(changingContent) ? 'person_photo--hide' : ''
		];

        return (

			<div className="views" id="scene">
			
				<Helmet>
	                <title>01 Mensagens - Relatório Anual 2018 | ANBIMA</title>
	            </Helmet>

				<div className="views_container">

		        	<article className={ classItem.join(' ') }>

		        		<header className="views__header">
		        			<div className="container">
				        		<h1><span>01</span> Mensagens</h1>
		        			</div>
		        		</header>

		        		<div className="views__content first__view row">
		        			<div className="gradient"></div>
	        				<div className="person_select">
			        			<div className="container">
			        				{ selectors }
				        		</div>
	        				</div>
	        				<div className={ imageClasses.join(' ') }>
	        					<img src={ this.state.selectedPerson.image } />
	        				</div>

		        			<div className={ contentClasses.join(' ') }>
			        			<div className="container mensagens_presidencia">
					        		<div className="column">
										<p className="gri_p"> 
					        				<span className="gri_label"><text>GRI 102-14</text></span>
										</p>

						        		<div className="title_presidencia">
						        			<span className="bg_word">{ this.state.selectedPerson.second_name }</span>

						        			<h3>Mensagem da <strong>{ this.state.selectedPerson.title }</strong></h3>
						        			<h1>{ this.state.selectedPerson.name }</h1>
						        		</div>

						        		<div className="mensagem">
						        			{ renderHTML(this.state.selectedPerson.text) }
						        		</div>

					        		</div>
				        		</div>
			        		</div>

			        	</div>

		        	</article>

        		</div>
    		</div>
    	);
	}
}

export { Mensagens };
